export { SecretsComponent } from './secrets.component'; 